import React, { useState, useEffect } from "react";
import SectionTitle from "../../../components/SectionTitle";
import BannerNewsItem from "../../../components/BannerNewsItem";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import axios from "axios";
import NewsFirstColPlaceholder from "./placeholders/NewsFirstColPlaceholder";
import { getContent } from "../../../utils/main";

const NewsSecondCol = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const list = {
    visible: {
      opacity: 1,
      transition: {
        type: "spring",
        when: "",
        staggerChildren: 0.3,
      },
    },
    hidden: {
      opacity: 0,
      transition: {
        when: "afterChildren",
      },
    },
  };
  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/posts/get-posts/beyleki-habarlar/?size=30`
      )
      .then((res) => {
        setPosts(res.data["results"]);
      })
      .then(() => {
        setIsLoading(false);
      });
  }, []);

  const buildList = (posts, lang) => {
    let list = [];
    let count = 0;
    for(var i=0; i<posts.length; i++){
      if (lang === 'en'){
        if (posts[i].name_en !== null && posts[i].name_en !== "" && count < 4){
          list.push(<BannerNewsItem post={posts[i]} key={[posts[i].id]} />);
          count = count + 1;
        }
      } else if (lang === 'ru'){
        if (posts[i].name_ru !== null && posts[i].name_ru !== "" && count < 4){
          list.push(<BannerNewsItem post={posts[i]} key={[posts[i].id]} />);
          count = count + 1;
        }
      } else {
        if (posts[i].name_tm !== null && posts[i].name_tm !== "" && count < 4){
          list.push(<BannerNewsItem post={posts[i]} key={[posts[i].id]} />);
          count = count + 1;
        }
      }
    }
    return list
  }

  return isLoading === true ? (
    <NewsFirstColPlaceholder />
  ) : (
    <motion.div variants={list} initial="hidden" animate="visible">
      <SectionTitle
        text={getContent(content, "Other news", lang)}
        color={"#fd7b00"}
      />
      {
        buildList(posts, lang)
      }
    </motion.div>
  );
};

export default NewsSecondCol;
